import { Icon } from "@iconify/react";

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

// Full super-admin sidebar
const sidebarConfig = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  // ── Admin ──────────────────────────────────────────
  {
    title: "Administrator",
    path: "/dashboard/admin",
    icon: getIcon("eva:person-fill"),
    sectionTitle: "Admin",
    children: [
      { title: "Add Admin", path: "addadmin" },
      { title: "Admin List", path: "adminlist" },
    ],
  },
  {
    title: "App Settings",
    path: "/appsettings",
    icon: getIcon("eva:settings-2-fill"),
  },
  {
    title: "Audit Log",
    path: "/auditlog",
    icon: getIcon("eva:clipboard-fill"),
  },
  // ── Users ──────────────────────────────────────────
  {
    title: "User Management",
    path: "/users",
    icon: getIcon("fa-solid:users"),
    sectionTitle: "Users",
  },
  {
    title: "Reported Users",
    path: "/reported",
    icon: getIcon("eva:alert-triangle-fill"),
  },
  {
    title: "Content Moderation",
    path: "/contentmoderation",
    icon: getIcon("eva:shield-fill"),
  },
  {
    title: "Subscriptions",
    path: "/subscriptions",
    icon: getIcon("eva:credit-card-fill"),
  },
  // ── Communication ──────────────────────────────────
  {
    title: "Mass Notification",
    path: "/mass",
    icon: getIcon("ant-design:message-filled"),
    sectionTitle: "Communication",
  },
  {
    title: "DM Center",
    path: "/dm",
    icon: getIcon("eva:message-square-fill"),
  },
  // ── Analytics ──────────────────────────────────────
  {
    title: "FIV Monitor",
    path: "/fivmonitor",
    icon: getIcon("fa-solid:chart-line"),
    sectionTitle: "Analytics",
  },
  {
    title: "Top FIV Meters",
    path: "/topfiv",
    icon: getIcon("octicon:database-16"),
  },
  {
    title: "Revenue & Growth",
    path: "/revenuecharts",
    icon: getIcon("eva:trending-up-fill"),
  },
  {
    title: "Brokerage Health",
    path: "/brokeragehealth",
    icon: getIcon("eva:activity-fill"),
  },
  {
    title: "Stream Monitor",
    path: "/streammonitor",
    icon: getIcon("eva:video-fill"),
  },
  // ── Monetization ───────────────────────────────────
  {
    title: "Token & Gifts",
    path: "/tokengifts",
    icon: getIcon("eva:gift-fill"),
    sectionTitle: "Monetization",
  },
  {
    title: "Payout Tracker",
    path: "/payouttracker",
    icon: getIcon("fa-solid:file-invoice-dollar"),
  },
  {
    title: "Money Requests",
    path: "/dashboard/money",
    icon: getIcon("eva:credit-card-outline"),
    children: [
      { title: "Pending", path: "pendingmoneyrequest" },
      { title: "Accepted", path: "acceptmoneyrequest" },
      { title: "Declined", path: "declinemoneyrequest" },
    ],
  },
  // ── Creators ───────────────────────────────────────
  {
    title: "Creator Requests",
    path: "/creatorrequest",
    icon: getIcon("fa:street-view"),
    sectionTitle: "Creators",
  },
  {
    title: "Creator List",
    path: "/creatorslist",
    icon: getIcon("eva:people-fill"),
  },
  // ── Finance ────────────────────────────────────────
  {
    title: "Financial Ledger",
    path: "/ledger",
    icon: getIcon("fa-solid:money-check-alt"),
    sectionTitle: "Finance",
  },
  {
    title: "Support",
    path: "/support",
    icon: getIcon("eva:headphones-fill"),
  },
];

// Sub-admin sidebar (limited access)
const sidebarConfig2 = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  {
    title: "User Management",
    path: "/users",
    icon: getIcon("fa-solid:users"),
    sectionTitle: "Users",
  },
  {
    title: "Reported Users",
    path: "/reported",
    icon: getIcon("eva:alert-triangle-fill"),
  },
  {
    title: "Content Moderation",
    path: "/contentmoderation",
    icon: getIcon("eva:shield-fill"),
  },
  {
    title: "Mass Notification",
    path: "/mass",
    icon: getIcon("ant-design:message-filled"),
    sectionTitle: "Communication",
  },
  {
    title: "DM Center",
    path: "/dm",
    icon: getIcon("eva:message-square-fill"),
  },
  {
    title: "FIV Monitor",
    path: "/fivmonitor",
    icon: getIcon("fa-solid:chart-line"),
    sectionTitle: "Analytics",
  },
  {
    title: "Stream Monitor",
    path: "/streammonitor",
    icon: getIcon("eva:video-fill"),
  },
  {
    title: "Support",
    path: "/support",
    icon: getIcon("eva:headphones-fill"),
  },
];

const config = { sidebarConfig, sidebarConfig2 };
export default config;
